(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wvr-post-hero-usp-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wvr-post-hero-usp')) {
    customElements.define('wvr-post-hero-usp', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;
        this.video = this.querySelector('.wvr-usp__video');
        this.cues = [...this.querySelectorAll('[data-wvr-usp-cue]')];
        if (!this.video) return;
        try {
          this.media = JSON.parse(this.querySelector('[data-wvr-usp-media]').textContent);
        } catch {
          return;
        }
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.connection = navigator.connection;
        this.pageLoaded = document.readyState === 'complete';
        this.inView = false;
        this.autoplayBlocked = false;
        this.mediaFailed = false;
        this.playPending = false;
        this.attempt = (this.attempt || 0) + 1;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = false;
        this.resetMediaState();
        this.video.addEventListener('playing', () => {
          if (!this.mayPlay()) {
            this.stop();
            return;
          }
          this.frameWasPlaying = true;
          this.revealFrame();
          this.setPlaying(true);
        }, { signal });
        this.video.addEventListener('pause', () => this.setPlaying(false), { signal });
        this.video.addEventListener('loadedmetadata', () => {
          this.seekToStart();
          this.updateCue();
        }, { signal });
        this.video.addEventListener('timeupdate', () => this.updateCue(), { signal });
        this.video.addEventListener('seeked', () => {
          this.startPending = false;
          this.revealFrame();
          this.updateCue();
        }, { signal });
        this.video.addEventListener('ended', () => {
          this.setPlaying(false);
          this.seekToStart();
          this.updateCue();
          this.syncPlayback();
        }, { signal });
        this.video.addEventListener('error', () => {
          this.mediaFailed = true;
          this.stop();
          this.resetMediaState();
        }, { signal });
        this.mobileQuery.addEventListener('change', () => this.selectMedia(), { signal });
        this.motionQuery.addEventListener('change', () => this.preferenceChanged(), { signal });
        this.connection?.addEventListener('change', () => this.preferenceChanged(), { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        window.addEventListener('load', () => {
          this.pageLoaded = true;
          this.syncPlayback();
        }, { signal, once: true });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.1;
            this.syncPlayback();
          }, { threshold: [0, 0.1] });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.autoplayBlocked = true;
        }
        this.selectMedia();
      }

      selectMedia() {
        const desktop = Array.isArray(this.media.desktop) ? this.media.desktop : [];
        const mobile = Array.isArray(this.media.mobile) ? this.media.mobile : [];
        const sources = this.mobileQuery.matches && mobile.length ? mobile : desktop.length ? desktop : mobile;
        const playable = sources.filter((source) => source.url && this.video.canPlayType(source.mime_type || 'video/mp4'));
        const mp4 = playable.filter((source) => source.mime_type === 'video/mp4' || source.format === 'mp4');
        const choices = (mp4.length ? mp4 : playable).slice().sort((a, b) => (a.width || 0) - (b.width || 0));
        const targetWidth = Math.min(this.clientWidth * Math.min(window.devicePixelRatio || 1, 1.5), 1920);
        const selected = choices.find((source) => source.width >= targetWidth) || choices[choices.length - 1];
        const nextSource = selected?.url || '';
        if (nextSource === this.selectedSource) {
          this.updateCue();
          return;
        }
        this.stop();
        this.resetMediaState();
        this.selectedSource = nextSource;
        this.autoplayBlocked = false;
        this.mediaFailed = false;
        if (this.video.hasAttribute('src')) {
          this.video.removeAttribute('src');
          this.video.load();
        }
        this.syncPlayback();
      }

      preferenceChanged() {
        this.syncPlayback();
      }

      timeline() {
        const mobileTiming = this.mobileQuery.matches && this.dataset.mobileCueTiming === 'true';
        const start = Number(mobileTiming ? this.dataset.mobilePlaybackStart : this.dataset.playbackStart);
        const adjust = Number(mobileTiming ? this.dataset.mobileCueAdjustStart : this.dataset.cueAdjustStart);
        const aligned = Number(mobileTiming ? this.dataset.mobileCueAlignedStart : this.dataset.cueAlignedStart);
        return {
          start: Number.isFinite(start) ? Math.max(0, start) : 0,
          adjust: Number.isFinite(adjust) ? Math.max(0, adjust) : 2.8,
          aligned: Number.isFinite(aligned) ? Math.max(adjust || 0, aligned) : 4.3
        };
      }

      seekToStart() {
        if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        const start = Math.min(this.timeline().start, Math.max(0, this.video.duration - 0.1));
        this.startPending = Math.abs(this.video.currentTime - start) > 0.001;
        if (this.startPending) this.video.currentTime = start;
      }

      revealFrame() {
        if (!this.frameWasPlaying || this.startPending || this.video.seeking || this.video.readyState < 2 || this.mediaFailed) return;
        this.setAttribute('data-media-ready', '');
        this.updateCue();
      }

      updateCue() {
        if (!this.hasAttribute('data-media-ready') || this.startPending || this.video.seeking || this.mediaFailed || !this.selectedSource) return;
        const time = this.video.currentTime;
        const timeline = this.timeline();
        const phase = time >= timeline.aligned ? 2 : time >= timeline.adjust ? 1 : 0;
        this.setAttribute('data-cue-index', String(phase));
        this.cues.forEach((cue, index) => { cue.hidden = index !== phase; });
      }

      resetMediaState() {
        this.startPending = true;
        this.frameWasPlaying = false;
        this.removeAttribute('data-media-ready');
        this.removeAttribute('data-cue-index');
        this.cues.forEach((cue) => { cue.hidden = true; });
      }

      mayPlay() {
        const preferenceAllows = !this.motionQuery.matches && !this.connection?.saveData;
        return this.isConnected && this.pageLoaded && this.inView && !document.hidden && !this.autoplayBlocked && !this.mediaFailed && this.selectedSource && preferenceAllows;
      }

      syncPlayback() {
        if (!this.mayPlay()) {
          this.stop();
          return;
        }
        if (this.playPending || !this.video.paused) return;
        if (this.video.getAttribute('src') !== this.selectedSource) this.video.src = this.selectedSource;
        this.video.muted = true;
        this.playPending = true;
        const attempt = ++this.attempt;
        const result = this.video.play();
        if (result && typeof result.then === 'function') {
          result.then(() => {
            if (attempt !== this.attempt) return;
            this.playPending = false;
            if (!this.mayPlay()) this.stop();
          }).catch(() => {
            if (attempt !== this.attempt) return;
            this.playPending = false;
            this.autoplayBlocked = true;
            this.setPlaying(false);
          });
        } else {
          this.playPending = false;
        }
      }

      setPlaying(playing) {
        this.toggleAttribute('data-playing', playing);
      }

      stop() {
        this.attempt = (this.attempt || 0) + 1;
        this.playPending = false;
        this.video.pause();
        this.setPlaying(false);
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.stop();
        this.resetMediaState();
        this.controller.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.video.removeAttribute('src');
        this.video.load();
        this.selectedSource = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
